export default __webpack_public_path__ + "static/cruiselines-carnival-activities-5-f18c3b24450d284e94e156125f932917.jpg";